const homePageReviews = [
  {
    name: "Amit Sharma",
    text: "This website has an incredible selection of gadgets! The quality is excellent, and the delivery was super fast. Highly recommend!",
    stars: 5,
  },
  {
    name: "Priya Verma",
    text: "I've been a regular customer, and their customer service is top-notch. The products are always authentic, and the discounts are great!",
    stars: 3,
  },
  {
    name: "Rahul Mehta",
    text: "Smooth shopping experience. The website is user-friendly, and the checkout process is seamless. Will definitely shop again.",
    stars: 4,
  },
  {
    name: "Neha Joshi",
    text: "Good collection and reasonable prices. However, I wish they had more stock for certain premium gadgets.",
    stars: 3,
  },
  {
    name: "Vikram Singh",
    text: "Exceeded my expectations! The product quality is fantastic, and the fast delivery was a big plus. Will recommend to friends!",
    stars: 5,
  },
];

export default homePageReviews;
